import {
	collection,
	onSnapshot,
	query,
	where,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { ViewerComment } from "../types/comments.types";

export function useViewerComments(
	broadcastId: string | null,
	uid: string | null,
): ViewerComment[] {
	const [comments, setComments] = useState<ViewerComment[]>([]);

	useEffect(() => {
		if (!broadcastId || !uid) return;

		const q = query(
			collection(db, "broadcasts", broadcastId, "comments"),
			where("userId", "==", uid),
		);

		return onSnapshot(q, (snap) => {
			const docs = snap.docs.map((d) => ({
				id: d.id,
				...(d.data() as Omit<ViewerComment, "id">),
			}));
			docs.sort((a, b) => b.date.localeCompare(a.date));
			setComments(docs);
		});
	}, [broadcastId, uid]);

	return comments;
}
